module.exports = __webpack_public_path__ + "static/img/anxun12.ceff3b4a.png";